<app-mobile-header-menu menulink="/menu/documentos"></app-mobile-header-menu>
<aside class="sidebar">
  <!-- Always -->
  <header class="sidebar__header">
    <a class="sidebar__header-brand" (click)="goBack(true)">
      @if (whitelabelService.whitelabel?.pdf_logo_mini) {
        <img [src]="whitelabelService.whitelabel?.pdf_logo_mini" />
      }
    </a>

    <a class="btn-M btn-text icon-start" (click)="goBack()">
      <i class="fal fa-chevron-left"></i>
      {{ 'button.back' | translate }}
    </a>

    @if (isRendered) {
      <button class="btn-M btn-filled" (click)="createTemplate()">{{ 'button.save' | translate }}</button>
    } @else {
      <button class="btn-M btn-filled rendering"></button>
    }
  </header>

  <!-- NOVO FORMULÁRIO E ÁREA DOS CAMPOS -->

  <form class="form">
    <div class="form__top">
      <h2 class="form__title">{{ 'documents.fields.fields' | translate }}</h2>
      <button class="btn-M btn-text icon-start" (click)="startCreateNewField()">
        <i class="fal fa-brackets-curly"></i>
        {{ 'documents.fields.createField' | translate }}
      </button>
    </div>

    <p class="form__description">{{ 'documents.fields.informFieldDesc' | translate }}</p>
  </form>

  <div class="fields__type">
    {{ 'documents.fields.textFields' | translate }}

    <div class="fields__box">
      @for (customField of customFields; track $index) {
        <span
          class="field--default"
          draggable="true"
          [attr.data-field-type]="customField.type"
          [attr.data-signer-id]="customField.signer"
          [attr.data-field-name]="customField.name"
          (dragstart)="onDragFieldStart($event, customField)"
          (click)="insertInlineField(customField)"
        >
          {{ customField.name }}
        </span>
      }
    </div>
  </div>

  <!-- Campos de marcação e assinatura/rubrica (mais para frente) -->

  <!-- <div class="fields__type">
    {{ 'documents.fields.checkboxFields' | translate }}

    <div class="fields__box">
      <ng-container *ngFor="let customField of customFields">
        <span class="field--default" draggable="true" *ngIf="customField.type == 'checkboxField'" [attr.data-field-type]="customField.type" [attr.data-signer-id]="customField.signer">
          <i class="fal fa-grip-dots-vertical"></i>
          {{ customField.name }}
        </span>
      </ng-container>
    </div>
  </div>

  <div class="fields__type">
    {{ 'documents.fields.otherFields' | translate }}

    <div class="fields__box">
      <ng-container *ngFor="let customField of customFields">
        <span
          class="field--default"
          draggable="true"
          *ngIf="['signatureField', 'initialField'].includes(customField.type)"
          [attr.data-field-type]="customField.type"
          [attr.data-signer-id]="customField.signer"
        >
          <i class="fal fa-grip-dots-vertical"></i>
          {{ customField.name }}
        </span>
      </ng-container>
    </div>
  </div> -->
</aside>

<section class="template" [class.d-none]="!isRendered" (scroll)="$event && positionFloatingElements()">
  <div id="editor-toolbar">
    <div class="toolbar__top">
      <button class="toolbar__option" (click)="openToolbarDropdown(ToolbarDropdownOptions.Edit)">
        <span>{{ 'documents.editor.edit' | translate }}</span>
        <div class="toolbar__dropdown editor-dropdown" [attr.data-dropdown-option]="ToolbarDropdownOptions.Edit">
          <div class="dropdown__option" (click)="callHistoryAction('undo')">
            <div class="option__left">
              <i class="fal fa-rotate-left"></i>
              <span>{{ 'documents.editor.undo' | translate }}</span>
            </div>

            <div class="option__right">
              <div class="os_icon" [class]="currentOS == 'macOS' && 'fal fa-command'">{{ currentOS != 'macOS' ? 'Ctrl + ' : '' }}</div>
              Z
            </div>
          </div>

          <button class="dropdown__option" (click)="callHistoryAction('redo')">
            <div class="option__left">
              <i class="fal fa-rotate-right"></i>
              <span>{{ 'documents.editor.redo' | translate }}</span>
            </div>

            <div class="option__right">
              <div class="os_icon" [class]="currentOS == 'macOS' && 'fal fa-command'">{{ currentOS != 'macOS' ? 'Ctrl + ' : '' }}</div>
              Y
            </div>
          </button>

          <div class="dropdown__separator"></div>

          <button class="dropdown__option" (click)="callClipboardAction('cut')">
            <div class="option__left">
              <i class="fal fa-scissors"></i>
              <span>{{ 'documents.editor.cut' | translate }}</span>
            </div>

            <div class="option__right">
              <div class="os_icon" [class]="currentOS == 'macOS' && 'fal fa-command'">{{ currentOS != 'macOS' ? 'Ctrl + ' : '' }}</div>
              X
            </div>
          </button>

          <button class="dropdown__option" (click)="callClipboardAction('copy')">
            <div class="option__left">
              <i class="fal fa-copy"></i>
              <span>{{ 'documents.editor.copy' | translate }}</span>
            </div>

            <div class="option__right">
              <div class="os_icon" [class]="currentOS == 'macOS' && 'fal fa-command'">{{ currentOS != 'macOS' ? 'Ctrl + ' : '' }}</div>
              C
            </div>
          </button>

          <button class="dropdown__option" (click)="callClipboardAction('paste')">
            <div class="option__left">
              <i class="fal fa-paste"></i>
              <span>{{ 'documents.editor.paste' | translate }}</span>
            </div>

            <div class="option__right">
              <div class="os_icon" [class]="currentOS == 'macOS' && 'fal fa-command'">{{ currentOS != 'macOS' ? 'Ctrl + ' : '' }}</div>
              V
            </div>
          </button>

          <button class="dropdown__option" (click)="callClipboardAction('pastePlain')">
            <div class="option__left">
              <i class="fal fa-clipboard"></i>
              <span>{{ 'documents.editor.pasteAsText' | translate }}</span>
            </div>
          </button>

          <div class="dropdown__separator"></div>

          <button class="dropdown__option" (click)="selectAll()">
            <div class="option__left">
              <i class="fal fa-square-dashed"></i>
              <span>{{ 'documents.editor.selectAll' | translate }}</span>
            </div>

            <div class="option__right">
              <div class="os_icon" [class]="currentOS == 'macOS' && 'fal fa-command'">{{ currentOS != 'macOS' ? 'Ctrl + ' : '' }}</div>
              A
            </div>
          </button>

          <div class="dropdown__separator"></div>

          <button class="dropdown__option" (click)="openFindAndReplaceModal()">
            <div class="option__left">
              <i class="fal fa-magnifying-glass"></i>
              <span>{{ 'documents.editor.findAndReplace' | translate }}</span>
            </div>

            <div class="option__right">
              <div class="os_icon" [class]="currentOS == 'macOS' && 'fal fa-command'">{{ currentOS != 'macOS' ? 'Ctrl + ' : '' }}</div>
              F
            </div>
          </button>
        </div>
      </button>

      <div class="toolbar__separator"></div>

      <button class="toolbar__option" (click)="openToolbarDropdown(ToolbarDropdownOptions.Insert)">
        <span>{{ 'documents.editor.insert' | translate }}</span>
        <div class="toolbar__dropdown editor-dropdown" [attr.data-dropdown-option]="ToolbarDropdownOptions.Insert">
          <button class="dropdown__option" (mouseover)="openOptionDropdown(ToolbarDropdownSecondaryOptions.Image)">
            <div class="option__left">
              <i class="fal fa-image"></i>
              <span>{{ 'documents.editor.insertImage' | translate }}</span>
            </div>

            <div class="option__right">
              <i class="fal fa-chevron-right"></i>
            </div>

            <div class="option__dropdown editor-dropdown" [attr.data-dropdown-option]="ToolbarDropdownSecondaryOptions.Image">
              <button class="dropdown__option" (click)="insertImageWithLink()">
                <div class="option__left">
                  <i class="fal fa-link"></i>
                  <span>{{ 'documents.editor.insertWithLink' | translate }}</span>
                </div>
              </button>

              <label class="dropdown__option" for="insertImageFileInput">
                <div class="option__left">
                  <i class="fal fa-file"></i>
                  <span>{{ 'documents.editor.chooseFile' | translate }}</span>
                </div>
              </label>
              <input
                type="file"
                accept="image/png, image/jpeg, image/xml+svg, image/webp"
                name="insertImageFileInput"
                id="insertImageFileInput"
                class="toolbar__input--file"
                (change)="insertImageByFile($event)"
              />
            </div>
          </button>

          <button class="dropdown__option" (mouseover)="openOptionDropdown(ToolbarDropdownSecondaryOptions.Table)">
            <div class="option__left">
              <i class="fal fa-table"></i>
              <span>{{ 'documents.editor.insertTable' | translate }}</span>
            </div>

            <div class="option__right">
              <i class="fal fa-chevron-right"></i>
            </div>

            <div class="option__dropdown option__dropdown--special editor-dropdown" [attr.data-dropdown-option]="ToolbarDropdownSecondaryOptions.Table">
              <div class="table__dropdown dropdown-menu show">
                <ng-container [ngTemplateOutlet]="insertTableGrid" [ngTemplateOutletContext]="{ isDropdownOption: true }"></ng-container>
              </div>
            </div>
          </button>

          <button class="dropdown__option" (mouseover)="openOptionDropdown()" (click)="insertSummary()">
            <div class="option__left">
              <i class="fal fa-list-tree"></i>
              <span>{{ 'documents.editor.insertSummary' | translate }}</span>
            </div>
          </button>
        </div>
      </button>

      <div class="toolbar__separator"></div>

      <button class="toolbar__option" (click)="openToolbarDropdown(ToolbarDropdownOptions.View)">
        <span>{{ 'documents.editor.view' | translate }}</span>
        <div class="toolbar__dropdown editor-dropdown" [attr.data-dropdown-option]="ToolbarDropdownOptions.View">
          <button class="dropdown__option" (click)="toggleDynamicTemplateView('mobile')" [ngClass]="{ 'dropdown__option--active': currentView === 'mobile' }">
            <div class="option__left">
              <i class="fal fa-mobile-notch"></i>
              <span>{{ 'documents.editor.viewAsMobile' | translate }}</span>
            </div>
          </button>

          <button class="dropdown__option" (click)="toggleDynamicTemplateView('desktop')" [ngClass]="{ 'dropdown__option--active': currentView === 'desktop' }">
            <div class="option__left">
              <i class="fal fa-display"></i>
              <span>{{ 'documents.editor.viewAsDesktop' | translate }}</span>
            </div>
          </button>

          <div class="dropdown__separator"></div>

          <button class="dropdown__option" (click)="openSourceCode()">
            <div class="option__left">
              <i class="fal fa-code-simple"></i>
              <span>{{ 'documents.editor.viewSourceCode' | translate }}</span>
            </div>
          </button>
        </div>
      </button>

      <div class="toolbar__separator"></div>

      <button class="toolbar__option" (click)="openToolbarDropdown(ToolbarDropdownOptions.Format)">
        <span>{{ 'documents.editor.format' | translate }}</span>
        <div class="toolbar__dropdown editor-dropdown" [attr.data-dropdown-option]="ToolbarDropdownOptions.Format">
          <button class="dropdown__option" (mouseover)="openOptionDropdown()" (click)="toggleBold()" [ngClass]="{ 'dropdown__option--active': isActive('bold') }">
            <div class="option__left">
              <i class="fal fa-bold"></i>
              <span>{{ 'documents.editor.bold' | translate }}</span>
            </div>

            <div class="option__right">
              <div class="os_icon" [class]="currentOS == 'macOS' && 'fal fa-command'">{{ currentOS != 'macOS' ? 'Ctrl + ' : '' }}</div>
              B
            </div>
          </button>

          <button class="dropdown__option" (mouseover)="openOptionDropdown()" (click)="toggleItalic()" [ngClass]="{ 'dropdown__option--active': isActive('italic') }">
            <div class="option__left">
              <i class="fal fa-italic"></i>
              <span>{{ 'documents.editor.italic' | translate }}</span>
            </div>

            <div class="option__right">
              <div class="os_icon" [class]="currentOS == 'macOS' && 'fal fa-command'">{{ currentOS != 'macOS' ? 'Ctrl + ' : '' }}</div>
              I
            </div>
          </button>

          <button class="dropdown__option" (mouseover)="openOptionDropdown()" (click)="toggleUnderline()" [ngClass]="{ 'dropdown__option--active': isActive('underline') }">
            <div class="option__left">
              <i class="fal fa-underline"></i>
              <span>{{ 'documents.editor.underline' | translate }}</span>
            </div>

            <div class="option__right">
              <div class="os_icon" [class]="currentOS == 'macOS' && 'fal fa-command'">{{ currentOS != 'macOS' ? 'Ctrl + ' : '' }}</div>
              U
            </div>
          </button>

          <button class="dropdown__option" (mouseover)="openOptionDropdown()" (click)="toggleStrike()" [ngClass]="{ 'dropdown__option--active': isActive('strike') }">
            <div class="option__left">
              <i class="fal fa-strikethrough"></i>
              <span>{{ 'documents.editor.deleted' | translate }}</span>
            </div>
          </button>

          <button class="dropdown__option" (mouseover)="openOptionDropdown()" (click)="toggleScript('super')" [ngClass]="{ 'dropdown__option--active': isActive('superscript') }">
            <div class="option__left">
              <i class="fal fa-superscript"></i>
              <span>{{ 'documents.editor.superscript' | translate }}</span>
            </div>
          </button>

          <button class="dropdown__option" (mouseover)="openOptionDropdown()" (click)="toggleScript('sub')" [ngClass]="{ 'dropdown__option--active': isActive('subscript') }">
            <div class="option__left">
              <i class="fal fa-subscript"></i>
              <span>{{ 'documents.editor.subscript' | translate }}</span>
            </div>
          </button>

          <div class="dropdown__separator"></div>

          <button class="dropdown__option" (mouseover)="openOptionDropdown()" (click)="indent(1)">
            <div class="option__left">
              <i class="fal fa-indent"></i>
              <span>{{ 'documents.editor.addIndentation' | translate }}</span>
            </div>
          </button>

          <button class="dropdown__option" (mouseover)="openOptionDropdown()" (click)="indent(-1)">
            <div class="option__left">
              <i class="fal fa-outdent"></i>
              <span>{{ 'documents.editor.removeIndentation' | translate }}</span>
            </div>
          </button>

          <div class="dropdown__separator"></div>

          <button class="dropdown__option" (mouseover)="openOptionDropdown()" (click)="showNumberedTitles()" [ngClass]="{ 'dropdown__option--active': isShowNumberedTitles }">
            <div class="option__left">
              <i class="fal fa-hashtag"></i>
              <span>{{ 'documents.editor.numberedTitles' | translate }}</span>
            </div>
          </button>

          <div class="dropdown__separator"></div>

          <button class="dropdown__option" (mouseover)="openOptionDropdown(ToolbarDropdownSecondaryOptions.Alignment)">
            <div class="option__left">
              <i class="fal fa-align-left"></i>
              <span>{{ 'documents.editor.alignment' | translate }}</span>
            </div>
            <div class="option__right">
              <i class="fal fa-chevron-right"></i>
            </div>

            <div class="option__dropdown editor-dropdown" [attr.data-dropdown-option]="ToolbarDropdownSecondaryOptions.Alignment">
              <button class="dropdown__option" (click)="setAlignment('left')" [ngClass]="{ 'dropdown__option--active': isActive({ textAlign: 'left' }) }">
                <div class="option__left">
                  <i class="fal fa-align-left"></i>
                  <span>{{ 'documents.editor.alignLeft' | translate }}</span>
                </div>
              </button>

              <button class="dropdown__option" (click)="setAlignment('center')" [ngClass]="{ 'dropdown__option--active': isActive({ textAlign: 'center' }) }">
                <div class="option__left">
                  <i class="fal fa-align-center"></i>
                  <span>{{ 'documents.editor.alignCenter' | translate }}</span>
                </div>
              </button>

              <button class="dropdown__option" (click)="setAlignment('right')" [ngClass]="{ 'dropdown__option--active': isActive({ textAlign: 'right' }) }">
                <div class="option__left">
                  <i class="fal fa-align-right"></i>
                  <span>{{ 'documents.editor.alignRight' | translate }}</span>
                </div>
              </button>

              <button class="dropdown__option" (click)="setAlignment('justify')" [ngClass]="{ 'dropdown__option--active': isActive({ textAlign: 'justify' }) }">
                <div class="option__left">
                  <i class="fal fa-align-justify"></i>
                  <span>{{ 'documents.editor.alignJustify' | translate }}</span>
                </div>
              </button>
            </div>
          </button>

          <div class="dropdown__separator"></div>

          <button class="dropdown__option" (mouseover)="openOptionDropdown(ToolbarDropdownSecondaryOptions.TextColor)">
            <div class="option__left">
              <i class="fal fa-font"></i>
              <span>{{ 'documents.editor.textColor' | translate }}</span>
            </div>

            <div class="option__right">
              <i class="fal fa-chevron-right"></i>
            </div>

            <div class="option__dropdown option__dropdown--special option__dropdown--colors editor-dropdown" [attr.data-dropdown-option]="ToolbarDropdownSecondaryOptions.TextColor">
              @for (lines of toolbarColors; track $index) {
                <div class="side_by_side">
                  @for (color of lines; track $index) {
                    <button
                      class="dropdown__option color__option"
                      [style.background]="(color || '#000000') + ' !important'"
                      (click)="setColor(color)"
                      [ngClass]="{ 'dropdown__option--active': isActive('textStyle', { color }) }"
                    ></button>
                  }
                </div>
              }

              <div class="side_by_side option">
                <button class="dropdown__option color__option color__option--with-icon" (click)="unsetColor()" [ngbTooltip]="tipToolbar" [tooltipContext]="{ tipText: 'clear' }">
                  <i class="fal fa-eraser"></i>
                </button>
                <label
                  class="dropdown__option color__option color__option--with-icon"
                  for="color__picker"
                  (click)="$event.stopPropagation()"
                  [ngbTooltip]="tipToolbar"
                  [tooltipContext]="{ tipText: 'custom' }"
                >
                  <i class="fal fa-palette"></i>
                  <input type="color" name="color__picker" id="color__picker" (change)="setColor()" />
                </label>
              </div>
            </div>
          </button>

          <button class="dropdown__option" (mouseover)="openOptionDropdown(ToolbarDropdownSecondaryOptions.BackgroundColor)">
            <div class="option__left">
              <i class="fal fa-highlighter"></i>
              <span>{{ 'documents.editor.backgroundColor' | translate }}</span>
            </div>

            <div class="option__right">
              <i class="fal fa-chevron-right"></i>
            </div>

            <div class="option__dropdown option__dropdown--special option__dropdown--colors editor-dropdown" [attr.data-dropdown-option]="ToolbarDropdownSecondaryOptions.BackgroundColor">
              @for (lines of toolbarColors; track $index) {
                <div class="side_by_side">
                  @for (color of lines; track $index) {
                    <button
                      class="dropdown__option color__option"
                      [style.background]="(color || '#000000') + ' !important'"
                      (click)="setBackground(color)"
                      [ngClass]="{ 'dropdown__option--active': isActive('highlight', { color }) }"
                    ></button>
                  }
                </div>
              }

              <div class="side_by_side option">
                <button class="dropdown__option color__option color__option--with-icon" (click)="unsetBackground()" [ngbTooltip]="tipToolbar" [tooltipContext]="{ tipText: 'clear' }">
                  <i class="fal fa-eraser"></i>
                </button>
                <label
                  class="dropdown__option color__option color__option--with-icon"
                  for="background__picker"
                  (click)="$event.stopPropagation()"
                  [ngbTooltip]="tipToolbar"
                  [tooltipContext]="{ tipText: 'custom' }"
                >
                  <i class="fal fa-palette"></i>
                  <input type="color" name="background__picker" id="background__picker" (change)="setBackground()" />
                </label>
              </div>
            </div>
          </button>

          <div class="dropdown__separator"></div>

          <button class="dropdown__option" (mouseover)="openOptionDropdown()" (click)="clearFormats()">
            <div class="option__left">
              <i class="fal fa-text-slash"></i>
              <span>{{ 'documents.editor.clearFormats' | translate }}</span>
            </div>
          </button>
        </div>
      </button>
    </div>

    <div class="toolbar__bottom">
      <span class="toolbar__formats">
        <app-select
          id="blockSelector"
          [attr.template-theme]="dynamicTemplateInput.theme || DynamicTemplateThemeEnum.Modern"
          #blockSelector
          [disableSearch]="true"
          [options]="blockOptions"
          [(ngModel)]="currentBlock"
          (ngModelChange)="setBlockType($event)"
        ></app-select>
      </span>

      <span class="toolbar__formats">
        <button class="toolbar__button" [ngClass]="{ 'toolbar__button--active': isActive('bold') }" [ngbTooltip]="tipToolbar" [tooltipContext]="{ tipText: 'bold' }" (click)="toggleBold()">
          <i class="fal fa-bold"></i>
        </button>
        <button class="toolbar__button" [ngClass]="{ 'toolbar__button--active': isActive('italic') }" [ngbTooltip]="tipToolbar" [tooltipContext]="{ tipText: 'italic' }" (click)="toggleItalic()">
          <i class="fal fa-italic"></i>
        </button>
        <button
          class="toolbar__button"
          [ngClass]="{ 'toolbar__button--active': isActive('underline') }"
          [ngbTooltip]="tipToolbar"
          [tooltipContext]="{ tipText: 'underline' }"
          (click)="toggleUnderline()"
        >
          <i class="fal fa-underline"></i>
        </button>
      </span>

      <span class="toolbar__formats">
        <button
          class="toolbar__button"
          [ngClass]="{ 'toolbar__button--active': isActive({ textAlign: 'left' }) }"
          [ngbTooltip]="tipToolbar"
          [tooltipContext]="{ tipText: 'alignLeft' }"
          (click)="setAlignment('left')"
        >
          <i class="fal fa-align-left"></i>
        </button>
        <button
          class="toolbar__button"
          [ngClass]="{ 'toolbar__button--active': isActive({ textAlign: 'center' }) }"
          [ngbTooltip]="tipToolbar"
          [tooltipContext]="{ tipText: 'alignCenter' }"
          (click)="setAlignment('center')"
        >
          <i class="fal fa-align-center"></i>
        </button>
        <button
          class="toolbar__button"
          [ngClass]="{ 'toolbar__button--active': isActive({ textAlign: 'right' }) }"
          [ngbTooltip]="tipToolbar"
          [tooltipContext]="{ tipText: 'alignRight' }"
          (click)="setAlignment('right')"
        >
          <i class="fal fa-align-right"></i>
        </button>
        <button
          class="toolbar__button"
          [ngClass]="{ 'toolbar__button--active': isActive({ textAlign: 'justify' }) }"
          [ngbTooltip]="tipToolbar"
          [tooltipContext]="{ tipText: 'alignJustify' }"
          (click)="setAlignment('justify')"
        >
          <i class="fal fa-align-justify"></i>
        </button>
      </span>

      <span class="toolbar__formats">
        <button
          class="toolbar__button"
          [ngClass]="{ 'toolbar__button--active': isActive('bulletList') }"
          [ngbTooltip]="tipToolbar"
          [tooltipContext]="{ tipText: 'unorderedList' }"
          (click)="toggleList('ul')"
        >
          <i class="fal fa-list-ul"></i>
        </button>
        <button
          class="toolbar__button"
          [ngClass]="{ 'toolbar__button--active': isActive('orderedList') }"
          [ngbTooltip]="tipToolbar"
          [tooltipContext]="{ tipText: 'orderedList' }"
          (click)="toggleList('ol')"
        >
          <i class="fal fa-list-ol"></i>
        </button>
        <button
          class="toolbar__button"
          [ngClass]="{ 'toolbar__button--active': isShowNumberedTitles }"
          [ngbTooltip]="tipToolbar"
          [tooltipContext]="{ tipText: 'numberedTitles' }"
          (click)="showNumberedTitles()"
        >
          <i class="fal fa-hashtag"></i>
        </button>
      </span>

      <span class="toolbar__formats">
        <div ngbDropdown placement="bottom-right">
          <button class="toolbar__button toolbar__button--dropdown" ngbDropdownToggle container="body" placement="right" [ngbTooltip]="tipToolbar" [tooltipContext]="{ tipText: 'insertImage' }">
            <i class="fal fa-image"></i>
          </button>
          <div ngbDropdownMenu class="image__dropdpown">
            <button ngbDropdownItem (click)="insertImageWithLink()">
              <i class="fal fa-link"></i>
              {{ 'documents.editor.insertWithLink' | translate }}
            </button>
            <label ngbDropdownItem for="insertImageByFileInput">
              <i class="fal fa-file"></i>
              {{ 'documents.editor.chooseFile' | translate }}
            </label>
            <input
              type="file"
              accept="image/png, image/jpeg, image/xml+svg, image/webp"
              name="insertImageByFileInput"
              id="insertImageByFileInput"
              class="toolbar__input--file"
              (change)="insertImageByFile($event)"
            />
          </div>
        </div>
      </span>

      <span class="toolbar__formats">
        <div ngbDropdown placement="bottom-right">
          <button class="toolbar__button toolbar__button--dropdown" ngbDropdownToggle container="body" placement="right" [ngbTooltip]="tipToolbar" [tooltipContext]="{ tipText: 'insertTable' }">
            <i class="fal fa-table"></i>
          </button>
          <div class="table__dropdown" ngbDropdownMenu>
            <ng-container [ngTemplateOutlet]="insertTableGrid" [ngTemplateOutletContext]="{ isDropdownOption: false }"></ng-container>
          </div>
        </div>
      </span>

      <span class="toolbar__formats">
        <button
          class="toolbar__button"
          [ngClass]="{ 'toolbar__button--active': currentView === 'mobile' }"
          (click)="toggleDynamicTemplateView('mobile')"
          [ngbTooltip]="tipToolbar"
          [tooltipContext]="{ tipText: 'viewAsMobile' }"
        >
          <i class="fal fa-mobile-notch"></i>
        </button>

        <button
          class="toolbar__button"
          [ngClass]="{ 'toolbar__button--active': currentView === 'desktop' }"
          (click)="toggleDynamicTemplateView('desktop')"
          [ngbTooltip]="tipToolbar"
          [tooltipContext]="{ tipText: 'viewAsDesktop' }"
        >
          <i class="fal fa-display"></i>
        </button>
      </span>
    </div>
  </div>

  <div class="editor__wrapper">
    <div
      id="editor"
      #editor
      [attr.template-theme]="dynamicTemplateInput.theme || DynamicTemplateThemeEnum.Modern"
      class="view--{{ currentView }}"
      [ngClass]="{ 'mobile--empty': currentView === 'mobile' && (!this.editor || this.editor.isEmpty) }"
      (drop)="onDropField($event)"
    ></div>

    @if (!this.editor || this.editor?.isEmpty) {
      <div id="dynamic-template-placeholder" class="forceDefaultColors" [attr.data-theme]="dynamicTemplateInput.theme || DynamicTemplateThemeEnum.Modern" [class]="'view--' + currentView">
        <h1>{{ 'documents.editor.explanation.whatAreTemplates' | translate }}</h1>
        <p>{{ 'documents.editor.explanation.whatAreTemplatesDesc1' | translate }}</p>
        <p [innerHTML]="'documents.editor.explanation.whatAreTemplatesDesc2' | translate"></p>
        <h2>{{ 'documents.editor.explanation.titlesAndContent' | translate }}</h2>
        <p>{{ 'documents.editor.explanation.titlesAndContentDesc' | translate }}</p>
        <h2>{{ 'documents.editor.explanation.dynamicFields' | translate }}</h2>
        <p>{{ 'documents.editor.explanation.dynamicFieldsDesc' | translate }}</p>
        <h2>{{ 'documents.editor.explanation.signersAndRoles' | translate }}</h2>
        <p>{{ 'documents.editor.explanation.signersAndRolesDesc1' | translate }}</p>
        <p>{{ 'documents.editor.explanation.signersAndRolesDesc2' | translate }}</p>
        <p>
          {{ 'documents.editor.explanation.signersAndRolesDesc3' | translate }}
          <span class="field--inline" data-color-id="1" data-field-after=" &#125;&#125;">{{ 'documents.fields.fullName' | translate }}</span>
        </p>
        <h2>{{ 'documents.editor.explanation.goodPractices' | translate }}</h2>
        <p>{{ 'documents.editor.explanation.goodPracticesDesc' | translate }}</p>
      </div>
    }
  </div>
</section>

@if (!isRendered) {
  <section class="template">
    <div class="template__header">
      <div class="template__header-container rendering"></div>
    </div>
    <div class="template__wrapper rendering">
      <div class="template__wrapper-paper"></div>
    </div>
  </section>
}

@if (showNewFieldBubble) {
  <div class="floating-bubble" [ngStyle]="newFieldBubbleCoordinates">
    <button class="floating-bubble__button" (click)="startCreateNewField()">
      <i class="fal fa-brackets-curly"></i>
      {{ 'documents.fields.createField' | translate }}
    </button>
  </div>
}

@if (isActive('table') && tableMenuCoordinates !== null) {
  <div class="floating-menu" [ngStyle]="tableMenuCoordinates">
    <button class="floating-menu__button" (click)="insertColumnBefore()" [ngbTooltip]="tipToolbar" [tooltipContext]="{ tipText: 'insertColumnBefore' }">
      <i [outerHTML]="tableMenuIcons?.insertColumnBefore"></i>
    </button>
    <button class="floating-menu__button" (click)="insertColumnAfter()" [ngbTooltip]="tipToolbar" [tooltipContext]="{ tipText: 'insertColumnAfter' }">
      <i [outerHTML]="tableMenuIcons?.insertColumnAfter"></i>
    </button>
    <button class="floating-menu__button" (click)="insertRowBefore()" [ngbTooltip]="tipToolbar" [tooltipContext]="{ tipText: 'insertRowBefore' }">
      <i [outerHTML]="tableMenuIcons?.insertRowBefore"></i>
    </button>
    <button class="floating-menu__button" (click)="insertRowAfter()" [ngbTooltip]="tipToolbar" [tooltipContext]="{ tipText: 'insertRowAfter' }">
      <i [outerHTML]="tableMenuIcons?.insertRowAfter"></i>
    </button>

    <i class="fal fa-pipe"></i>

    <button class="floating-menu__button" (click)="deleteColumn()" [ngbTooltip]="tipToolbar" [tooltipContext]="{ tipText: 'deleteColumn' }">
      <i [outerHTML]="tableMenuIcons?.deleteColumn"></i>
    </button>
    <button class="floating-menu__button" (click)="deleteRow()" [ngbTooltip]="tipToolbar" [tooltipContext]="{ tipText: 'deleteRow' }">
      <i [outerHTML]="tableMenuIcons?.deleteRow"></i>
    </button>
    <button class="floating-menu__button" (click)="deleteTable()" [ngbTooltip]="tipToolbar" [tooltipContext]="{ tipText: 'deleteTable' }">
      <i [outerHTML]="tableMenuIcons?.deleteTable"></i>
    </button>

    <i class="fal fa-pipe"></i>

    <button class="floating-menu__button" (click)="mergeCells()" [ngbTooltip]="tipToolbar" [tooltipContext]="{ tipText: 'mergeCells' }">
      <i [outerHTML]="tableMenuIcons?.mergeCells"></i>
    </button>
    <button class="floating-menu__button" (click)="splitCell()" [ngbTooltip]="tipToolbar" [tooltipContext]="{ tipText: 'splitCell' }">
      <i [outerHTML]="tableMenuIcons?.splitCell"></i>
    </button>

    <i class="fal fa-pipe"></i>

    <button class="floating-menu__button" (click)="toggleHeaderCell()" [ngbTooltip]="tipToolbar" [tooltipContext]="{ tipText: 'toggleHeaderCell' }">
      <i class="fal fa-table"></i>
    </button>
  </div>
}

<aside class="sidebar sidebar--on-right" [class.d-none]="showCreateEditSidebar">
  <div class="monster__tabs">
    <button type="button" class="tab__item" (click)="currentRightSidebarOption = 'signers'" [ngClass]="{ active: currentRightSidebarOption == 'signers' }">
      <i class="fa-regular fa-signature"></i>{{ 'documents.signatories' | translate }}
    </button>

    <button type="button" class="tab__item" (click)="currentRightSidebarOption = 'options'" [ngClass]="{ active: currentRightSidebarOption == 'options' }">
      <i class="fa-regular fa-gear"></i>{{ 'documents.options' | translate }}
    </button>
  </div>

  <form class="form" [class.d-none]="currentRightSidebarOption !== 'signers'">
    <p class="form__description">{{ 'documents.informSignerDescNew' | translate }}</p>

    @for (signer of signers; track $index) {
      <div class="signer">
        @if (!!signer?._extra) {
          <app-signer-input
            [signer]="signer"
            [document]="document"
            [qualified]="document.qualified"
            [context]="SignerInputContext.Editor"
            [isCountryBR]="currentUser?.locale?.country === 'BR'"
            [validationErrors]="(validationErrors.signers || [])[$index]"
            [class.has-error]="(validationErrors.signers || [])[$index]?.name || (validationErrors.signers || [])[$index]?.email"
            (changeSigner)="onSignerChange(signer)"
            [attr.signer-color-id]="$index % idColors.length"
            [signerIndex]="$index"
            (removeSigner)="removeSigner($event)"
            (keydown)="$event.key != 'Enter' || $event.preventDefault()"
          ></app-signer-input>
        }
      </div>
    }

    <button class="btn-M btn-text icon-start" (click)="addNewSigner(); $event.target.blur()">
      <i class="fal fa-plus"></i>
      {{ 'documents.addSignatory' | translate }}
    </button>
  </form>

  <form class="form" [class.d-none]="currentRightSidebarOption !== 'options'" [formGroup]="form">
    <div class="centermodal__form" formGroupName="dynamicTemplateOptions">
      <label class="field__holder" [appFormControlWrap]="form.get('dynamicTemplateOptions.name')">
        <input type="text" class="field" autocomplete="none" formControlName="name" required minlength="3" maxlength="255" />
        <span class="field__placeholder">{{ 'documents.templateOptions.name' | translate }}</span>
      </label>

      <label class="field__holder" [appFormControlWrap]="form.get('dynamicTemplateOptions.description')">
        <textarea type="text" class="field" autocomplete="none" formControlName="description" required minlength="3" maxlength="255"></textarea>
        <span class="field__placeholder">{{ 'documents.templateOptions.description' | translate }}</span>
      </label>

      <label class="field__holder" [appFormControlWrap]="form.get('dynamicTemplateOptions.keywords')">
        <input type="text" class="field" autocomplete="none" formControlName="keywords" required maxlength="255" />
        <span class="field__placeholder">{{ 'documents.templateOptions.keywords' | translate }}</span>

        <span class="field__helper">{{ 'documents.templateOptions.keywords.helper' | translate }}</span>
      </label>

      <!-- Por hora há apenas uma categoria, então o select será omitido -->
      <!-- <app-select placeholder="{{ 'documents.templateOptions.category' | translate }}" formControlName="category" [options]="categories" [disableSearch]="true"></app-select> -->

      <app-select placeholder="{{ 'profile.language' | translate }}" formControlName="lang" [options]="languages" [disableSearch]="true"></app-select>

      <!-- Opção de modelos privados será disponibilizada mais tarde -->
      <!-- <div class="sidemodal__switch" [appFormControlWrap]="form.get('dynamicTemplateOptions.templatePrivate')">
        <app-switch formControlName="templatePrivate"></app-switch>
        <span class="sidemodal__switch-name pro" data-pro-text="Pro">{{ 'documents.templateOptions.private' | translate }}</span>
      </div> -->

      <div class="centermodal__group-title">{{ 'documents.appearance' | translate }}</div>

      <app-select placeholder="{{ 'documents.templateOptions.theme' | translate }}" formControlName="theme" [disableSearch]="true" [options]="themes"> </app-select>
    </div>
  </form>
</aside>

<app-create-edit-fields-form
  #createEditFieldsComponent
  class="sidebar sidebar--on-right"
  [class.d-none]="!showCreateEditSidebar"
  [existingNames]="getExistingFieldNames()"
  [editor]="editor"
  (returnValue)="handleFieldOptionsFormReturn($event)"
  (closeSidebar)="showCreateEditSidebar = false"
></app-create-edit-fields-form>

<ng-template #insertTableGrid let-isDropdownOption="isDropdownOption">
  <span class="table__title">{{ 'documents.editor.insertTable' | translate }}</span>

  <div class="table__grid">
    @for (i of [1, 2, 3, 4, 5, 6]; track $index) {
      @for (j of [1, 2, 3, 4, 5, 6]; track $index) {
        <div class="table__unit" (mouseover)="onTableUnitHover(i, j, isDropdownOption)" (click)="insertTable(i, j)"></div>
      }
    }
  </div>
</ng-template>

<ng-template #tipToolbar let-tipText="tipText">
  <div class="tooltip__tip">{{ 'documents.editor.' + tipText | translate }}</div>
</ng-template>
